import { render, staticRenderFns } from "./SupportMessageConfirm.vue?vue&type=template&id=532b3462"
import script from "./SupportMessageConfirm.vue?vue&type=script&lang=js"
export * from "./SupportMessageConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports